import React from "react";
import './styles.css'
import Modal from "../../../components/modal";
import DataRenderer from "../../../components/render";

const renderers = [
    {
        id: 0,
        name: 'Latex ( Katex )',
        type:'latex',
    },
    {
        id: 1,
        name: 'Mathpix Markdown',
        type: 'mathpix',
    }
]


export default function Renderer() {

    const [inputText, setInputText] = React.useState('')
    const [selectedRenderer, setSelectedRenderer] = React.useState<number>(renderers[0].id)

    const [showModal, setShowModal] = React.useState(false)

    return (
        <div className="renderer_screen">
            <div className="page_wrapper">

                <div className="mobile_header re">
                    <div className="mobile_header__title">
                        <span>Hi Admin,</span>
                        <h2 className="heading">Latex Renderer</h2>
                    </div>

                    <div className='page-action-button re_button' onClick={() => setShowModal(true)}>
                        <span>Switch Renderer</span>
                    </div>
                </div>


                <div className="renderer_body">
                    <div className="re_container input">
                        <h3>Input</h3>
                        <textarea
                            onInput={(e) => setInputText(e.currentTarget.value)}
                            className="re_input"
                            placeholder="Enter your latex code here"
                        ></textarea>
                    </div>

                    <div className="re_container output">
                        <div className="re_header">
                            <h3>Output</h3>
                            <div className="re_header__actions">
                                {renderers[selectedRenderer].name}
                            </div>
                        </div>
                        <div className="re_output">
                            <DataRenderer text={inputText} type={renderers[selectedRenderer].type as 'latex' | 'mathpix'} />
                        </div>
                    </div>
                </div>


            </div>

            {
                showModal &&
                <Modal
                    onClose={() => setShowModal(false)}
                >
                    <div className="plans_holder_head">
                        <h2 className="modal_heading">Select Renderer</h2>
                        <span className="modal_description">Select any of the given renderer to view the output.</span>
                        <div className="sub_selector" style={{ marginTop: '20px' }}>
                            <div className="sub_holder">
                                {renderers.length > 0 &&
                                    renderers.map((thisRenderer, index) => (
                                        <div key={thisRenderer.id}
                                            className={`sub_chip ${selectedRenderer === thisRenderer.id ? 'selected' : ''}`}
                                            onClick={() => {
                                                setSelectedRenderer(thisRenderer.id)
                                                setShowModal(false)
                                            }}
                                        >
                                            {thisRenderer.name}
                                        </div>
                                    ))
                                }
                            </div>

                        </div>

                    </div>
                </Modal>
            }


        </div >
    )
}